
    import './styles.scoped.css';
    export default {
  "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_14gxj_97",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_14gxj_1",
  "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_14gxj_124",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_14gxj_1",
  "error": "awsui_error_14mhv_14gxj_97",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_14gxj_1",
  "root": "awsui_root_14mhv_14gxj_168",
  "label": "awsui_label_14mhv_14gxj_204",
  "info": "awsui_info_14mhv_14gxj_218",
  "description": "awsui_description_14mhv_14gxj_223",
  "constraint": "awsui_constraint_14mhv_14gxj_224",
  "hints": "awsui_hints_14mhv_14gxj_231",
  "constraint-has-error": "awsui_constraint-has-error_14mhv_14gxj_232",
  "secondary-control": "awsui_secondary-control_14mhv_14gxj_236",
  "controls": "awsui_controls_14mhv_14gxj_240",
  "label-hidden": "awsui_label-hidden_14mhv_14gxj_240",
  "control": "awsui_control_14mhv_14gxj_240",
  "error__message": "awsui_error__message_14mhv_14gxj_258",
  "visually-hidden": "awsui_visually-hidden_14mhv_14gxj_262"
};
  